/**
 * Acceptă o invitație și aliniază sesiunea locală: aduce lista de spații de pe
 * server și comută pe cel nou. Fără asta userul ar trebui să se relogheze ca
 * să vadă spațiul în care tocmai a intrat.
 */
import { authApi } from '@/api/auth';
import { invitesApi } from '@/api/invites';
import { useAuthStore } from '@/stores/auth';

export async function acceptInviteAndSync(token: string): Promise<void> {
  const result = await invitesApi.accept(token);
  const me = await authApi.me();
  useAuthStore.getState().syncTenants(me.tenants, result.tenant_id);
}
